import React from "react";

function History() {
  return (
    <div>
      <section className="history-wrapper bg-dark">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-6">
              {/* Section Heading */}
              <div className="section-heading text-center">
                <div className="sub-title text-white justify-content-center">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  History
                </div>
                <h2 className="text-white">Our History From Starting </h2>
              </div>
            </div>
          </div>
        </div>

        {/* Timeline */}
        <div className="container">
          <div className="lawgis-timeline">
            {/* Timeline Event */}
            <div
              className="timeline-event wow fadeInLeft"
              data-wow-delay="300ms"
              data-wow-duration="1000ms"
            >
              <div className="timeline-year">
                2016
                <img
                  className="timeline-img"
                  src="assets/img/bg-img/50.jpg"
                  alt=""
                />
                <div className="timeline-title">Launch Journey</div>
              </div>
            </div>

            {/* Timeline Event */}
            <div
              className="timeline-event wow fadeInLeft"
              data-wow-delay="500ms"
              data-wow-duration="1000ms"
            >
              <div className="timeline-year">
                2020
                <img
                  className="timeline-img"
                  src="assets/img/bg-img/51.jpg"
                  alt=""
                />
                <div className="timeline-title">Firm of Year</div>
              </div>
            </div>

            {/* Timeline Event */}
            <div
              className="timeline-event wow fadeInLeft"
              data-wow-delay="700ms"
              data-wow-duration="1000ms"
            >
              <div className="timeline-year">
                2022
                <img
                  className="timeline-img"
                  src="assets/img/bg-img/52.jpg"
                  alt=""
                />
                <div className="timeline-title">Open Branch</div>
              </div>
            </div>

            {/* Timeline Event */}
            <div
              className="timeline-event wow fadeInLeft"
              data-wow-delay="900ms"
              data-wow-duration="1000ms"
            >
              <div className="timeline-year">
                2024
                <img
                  className="timeline-img"
                  src="assets/img/bg-img/53.jpg"
                  alt=""
                />
                <div className="timeline-title">Global Award</div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default History;
